// extracted by mini-css-extract-plugin
module.exports = {"animate-height":"ShowPartners_animate-height__2mi4X","TableScroll":"ShowPartners_TableScroll__2s2bb","animateHeight":"ShowPartners_animateHeight__1mDR_"};